var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { dense: "", align: "center" } },
    [
      _vm.$vuetify.breakpoint.mdAndUp
        ? _c(
            "v-col",
            { staticClass: "text-center", attrs: { cols: "auto" } },
            [
              _c("v-icon", {
                class: { "mr-4": _vm.small },
                attrs: {
                  size: _vm.small ? 40 : 80,
                  color: _vm.lock ? "light-panel" : _vm.color
                },
                domProps: { innerHTML: _vm._s("cci-rank-" + _vm.rank) }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-col", [
        _c("p", {
          staticClass: "body-text px-3 ma-0 ml-n2",
          domProps: { innerHTML: _vm._s(_vm.talentRank.Description) }
        }),
        _vm._v(" "),
        _vm.talentRank.Actions.length
          ? _c(
              "div",
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "", justify: "center" } },
                  _vm._l(_vm.talentRank.Actions, function(a, i) {
                    return _c(
                      "v-col",
                      {
                        key: _vm.talentRank.Name + "_action_" + i,
                        attrs: { cols: "auto" }
                      },
                      [
                        _c("cc-action", {
                          staticClass: "ma-2",
                          attrs: { action: a, panel: !_vm.actionButtons }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.talentRank.Deployables.length
          ? _c(
              "div",
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "", justify: "center" } },
                  _vm._l(_vm.talentRank.Deployables, function(d, i) {
                    return _c(
                      "v-col",
                      {
                        key: _vm.talentRank.Name + "_deployable_" + i,
                        attrs: { cols: "auto" }
                      },
                      [
                        _c("cc-deployable-info", {
                          staticClass: "ma-2",
                          attrs: {
                            deployable: d,
                            panel: false,
                            "name-override": _vm.talentRank.Name
                          }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.talentRank.IntegratedEquipment.length
          ? _c(
              "div",
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "", justify: "center" } },
                  _vm._l(_vm.talentRank.IntegratedEquipment, function(x, i) {
                    return _c(
                      "v-col",
                      {
                        key: _vm.talentRank.Name + "_integrated_" + i,
                        attrs: { cols: "auto" }
                      },
                      [
                        _c("cc-integrated-info", {
                          attrs: { item: x, panel: false }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }